import axios from 'axios';
import constants from '../constants';

export default class GetData{
    constructor(token){
        this.token = token;
        this.HubZoneMap = {};
        this.hubListMap = {};
        this.bucketListMap = {};
        this.disputeStatusMap = {};
        this.ReasonList = {};
        this.hubzoneByHubIdMap = {};
        this.statusCodeList = {};
        this.actionstatusCodeList = {};


    }

    async getHubZone(){
        return new Promise((resolve, reject) => {
            const finalHubData = [];
            let list='';
           const fetching = axios({
                method: 'post',
                url: constants.api_url + 'getZoneList',
                data: {},
                headers: {
                  'Authorization': 'Bearer ' + this.token
                }
              });
    
            list = fetching.then(async res => {
                let hubZoneData = res.data.data?res.data.data:[]
                await hubZoneData.map((hub) => this.HubZoneMap[hub.hubzoneid] = hub.hubzonename );
                let response = {name: 'hubzoneList', map: this.HubZoneMap}
                return resolve(response);
            }).catch(error => {return reject(error)});
        })
        
    }

    async getHubList(){
        return new Promise((resolve, reject) => {
            const finalHubData = [];
            let list='';
           const fetching = axios({
                method: 'post',
                url: constants.api_url + 'getHubdropdownlist',
                data: {},
                headers: {
                  'Authorization': 'Bearer ' + this.token
                }
              });
    
            list = fetching.then(async res => {
                let hubsData = res.data.data?res.data.data:[]
                await hubsData.map((hub) => this.hubListMap[hub.HubID] = hub.HubName );
                let response = {name: 'hubList', map: this.hubListMap}
                return resolve(response);
            }).catch(error => {return reject(error)});
        })
        
    }

    async getDisputeStatusList(){
        return new Promise((resolve, reject) => {
            const finalHubData = [];
            let list='';
           const fetching = axios({
                method: 'post',
                url: constants.api_url + 'DisputeSubStatus',
                data: {},
                headers: {
                  'Authorization': 'Bearer ' + this.token
                }
              });
    
            list = fetching.then(async res => {
                let disputeStatusData = res.data.data?res.data.data:[]
                await disputeStatusData.map((disputeStatus) => this.disputeStatusMap[disputeStatus.pickupstatuscode] = disputeStatus.pickupstatusname );
                let response = {name: 'disputeStatusData', map: this.disputeStatusMap}
                return resolve(response);
            }).catch(error => {return reject(error)});
        })
        
    }

    async getReasonListB2B(){
      return new Promise((resolve, reject) => {
          const finalHubData = [];
          let list='';
          let inputPayload = {
            isactive:true
        }
         const fetching = axios({
              method: 'post',
              url: constants.api_url + 'fetchb2bReasons',
              data: inputPayload,
              headers: {
                'Authorization': 'Bearer ' + this.token
              }
            });
  
          list = fetching.then(async res => {
              let ReasonData = res.data.data?res.data.data:[]
              await ReasonData.map((bucket) => this.ReasonList[bucket.stdreasonsid] = bucket.stdreason );
              let response = {name: 'ReasonList', map: this.ReasonList}
              return resolve(response);
          }).catch(error => {return reject(error)});
      })
      
  }
  async getBucketList(){
    return new Promise((resolve, reject) => {
        const finalHubData = [];
        let list='';
       const fetching = axios({
            method: 'post',
            url: constants.api_url + 'getinvestigationbuckettype',
            data: {},
            headers: {
              'Authorization': 'Bearer ' + this.token
            }
          });

        list = fetching.then(async res => {
            let bucketData = res.data.data?res.data.data:[]
            await bucketData.map((bucket) => this.bucketListMap[bucket.investigatbuckettypeid] = bucket.buckettypename );
            let response = {name: 'bucketList', map: this.bucketListMap}
            return resolve(response);
        }).catch(error => {return reject(error)});
    })
    
}
async getStatustList(){
  return new Promise((resolve, reject) => {
      let list='';
     const fetching = axios({
          method: 'post',
          url: constants.api_url + 'status',
          data: {},
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        });

      list = fetching.then(async res => {
          let statusData = res.data.data?res.data.data:[]
          await statusData.map((status) => this.statusCodeList[status.statuscode] = status.statusname );
          let response = {name: 'statusList', map: this.statusCodeList}
          return resolve(response);
      }).catch(error => {return reject(error)});
  })
  
}
async getActionStatusCodeList(){
  return new Promise((resolve, reject) => {
      let list='';
     const fetching = axios({
          method: 'post',
          url: constants.api_url + 'allVerificationStatus',
          data: {},
          headers: {
            'Authorization': 'Bearer ' + this.token
          }
        });

      list = fetching.then(async res => {
          let actioncodeData = res.data.data?res.data.data:[]
          console.log(actioncodeData,"actioncodeData");
          await actioncodeData.map((action) => this.actionstatusCodeList[action.investigationactionmasterid] = action.actionname );
          let response = {name: 'actioncodeList', map: this.actionstatusCodeList}
          return resolve(response);
      }).catch(error => {return reject(error)});
  })
  
}

  async hubzoneByHubId(){
      return new Promise((resolve, reject) => {
          const finalHubData = [];
          let list='';
         const fetching = axios({
              method: 'post',
              url: constants.api_url + 'gethubzonByCurrentHubID',
              data: {"hubids" : []},
              headers: {
                'Authorization': 'Bearer ' + this.token
              }
            });
  
          list = fetching.then(async res => {
              let hubzoneByHubIdData = res.data.data?res.data.data:[]
              console.log(res.data.data);
              await hubzoneByHubIdData.map((Data) => this.hubzoneByHubIdMap[Data.HubID] = Data.HubZoneId );
              let response = {name: 'hubzoneByHubId', map: this.hubzoneByHubIdMap}
              return resolve(response);
          }).catch(error => {return reject(error)});
      })
      
  }
}



// WEBPACK FOOTER //
// ./src/Mappings/getDataClass.js